import * as React from 'react';
import LocalDiv from '../../localization/LocalDiv';
import { css } from '@emotion/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { COLORS } from '../../globalStyle/colors';
import { useMsgText } from '../../localization/hooks';
import { Str } from '../../localization/translationKeys';


const styles = {
  root:        css`
    display: flex;
    flex-direction: row;
    align-items: center;
  `,
  title:       css`
    flex-grow: 1;
    margin: 24px;
    font-weight: normal;
    font-size: 22px;
    color: ${COLORS.DARK_GREY};
  `,
  closeButton: css`
    border-radius: 0;
    border-width: 0;
    padding: 15px 20px;
    font-size: 25px;
    background-color: transparent;
    align-self: flex-start;
    justify-self: flex-end;
    
    &:hover {
      color: ${COLORS.BLUE};
      cursor: pointer;
    }
  `,
};


type Props = {
  dismissable?: boolean;
  onDismiss?: () => void;

  title?: string;

  className?: string;
};


/**
 * ModalHeader: a component that
 *
 * PureComponent: true
 * Redux Connected: false
 */
const ModalHeader: React.FC<Props> = props => {
  const closeLabel = useMsgText(Str.Close);

  return (
    <LocalDiv css={styles.root} className={props.className}>
      <h1 css={styles.title}>{props.title}</h1>
      {
        props.dismissable && (
          <button aria-label={closeLabel} onClick={props.onDismiss} css={styles.closeButton}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        )
      }
    </LocalDiv>
  );
};

ModalHeader.defaultProps = {
  dismissable: true,
};

export default ModalHeader;
